import { useLayoutEffect, useRef, useState } from "react"

/**
 *  Helper hook for getting a ref to be used for html elements
 *  Works exactly like useRef, except that it will update the ref when the initial setting of the ref's target happens
 * */
const useHtmlRef = <T extends HTMLElement>() => {
  const ref = useRef<T>(null)
  const [, setHasLoaded] = useState(false)

  useLayoutEffect(() => {
    if (ref.current) {
      setHasLoaded(true)
    }
  }, [])
  return ref
}

export default useHtmlRef
